import { withProps } from 'recompose'
import React from 'react'
import Markdown from 'react-markdown'

import { trackEvent } from '../../app/ga'
import {
  getFeedbackCfg,
  getFeedbackDefinition,
  getSocialShareDefinition,
} from '../../app/selectors'
import content from '../../content'
import SocialBar from '../../addons/social/SocialBar'
import Feedback from '../../addons/feedback/Feedback'

function buildShareMessage(messageTemplate, presentation) {
  return messageTemplate.replace(/{title}/g, presentation.title)
}

function PresentationContent({
  presentation,
  feedbackCfg,
  feedbackDef,
  socialShareDef,
}) {
  const { title, subtitle, text, presenter } = presentation
  const { providers, message, hashtag, url } = socialShareDef
  const shareMessage = buildShareMessage(message, presentation)
  return (
    <div>
      {!presenter.metaOnly && (
        <div>
          <img
            src={presenter.picture}
            alt={presenter.fullName}
            className="PresentationDetailPage-presenterPicture"
          />
          <h3>{presenter.fullName}</h3>
        </div>
      )}
      <div>
        <h1>{title}</h1>
        <strong>{subtitle}</strong>
        <Markdown source={text} />
        <SocialBar
          url={url}
          providers={providers}
          message={shareMessage}
          hashtag={hashtag}
          beforeShare={provider => trackEvent('social', provider, title)}
        />
      </div>
      <Feedback
        cfg={feedbackCfg}
        subjectId={'presentation_' + presentation.id}
        definition={feedbackDef}
      />
    </div>
  )
}

const withPageContent = withProps(ownProps => ({
  feedbackCfg: getFeedbackCfg(content),
  feedbackDef: getFeedbackDefinition(content, 'presentation'),
  socialShareDef: getSocialShareDefinition(content, 'presentation'),
}))

export default withPageContent(PresentationContent)



// WEBPACK FOOTER //
// ./src/containers/PresentationDetail/PresentationContent.js